module.exports = __webpack_public_path__ + "static/media/swaraj_855_xm.d96de10d.png";